/* eslint-disable */
import { createDashboardIcon, EDashboardIconSize, EDashboardIconType } from "./dashboardicon";

interface IActivityTitleOptions extends Partial<HTMLHeadingElement> {
	iconType: EDashboardIconType;
}

export function createActivityTitle({
	className = "",
	innerHTML = "",
	iconType,
	...rest
}: IActivityTitleOptions): HTMLHeadingElement {
	const title = Mapy.Util.node("h3", {
		className: `ui-activity-title ${className}`,
		innerHTML: `<div>${innerHTML}</div>`,
		...rest,
	}) as HTMLHeadingElement;
	const icon = createDashboardIcon({
		type: iconType,
		size: EDashboardIconSize.SMALL,
	});
	title.insertAdjacentElement("afterbegin", icon);

	return title;
}
